import { omit } from "lodash";

import salesChartLoading from "@assets/sales-v3-chart-loading.gif";
import { TitleSlide } from "@components/title-slide-view";
import { useLandingPageAnalyticsContext } from "@features/landing-page-analytics/hooks";
import { GET_LANDING_PAGE_REPORT_CHART } from "@gql/landing-page-analytics";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type GetLandingPageReportChart,
  type GetLandingPageReportChartVariables,
} from "@north-beam/nb-client-side";

import { ChartContent } from "./chart-content";

export const Chart = () => {
  const {
    tableState: { selectedRows },
    chartState: { chartView },
    reportTableVariables,
  } = useLandingPageAnalyticsContext();

  const { data, loading } = useNorthbeamQuery<
    GetLandingPageReportChart,
    GetLandingPageReportChartVariables
  >(GET_LANDING_PAGE_REPORT_CHART, {
    variables: {
      ...omit(reportTableVariables, [
        "sorting",
        "page",
        "perPage",
        "aggregateAll",
      ]),
      selectionFilters: selectedRows,
      chartView,
    },
  });

  if (loading || !data) {
    return (
      <div className="px-6 py-4 text-xs">
        <div className="px-6 py-4 bg-white border border-gray rounded-lg h-[582px]">
          <TitleSlide>
            <img
              src={salesChartLoading}
              alt="Chart loading gif"
              className="w-1/3 m-auto"
            />
          </TitleSlide>
        </div>
      </div>
    );
  }

  return (
    <div className="px-6 py-4 text-xs">
      <div className="px-6 pt-6 bg-white border border-gray rounded-lg">
        <ChartContent rows={data.me.landingPageReportChart.rows} />
      </div>
    </div>
  );
};
